/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    menu: "menu",
    defaultTrigger: "default-trigger",
};
export const SLOTS = {
    tooltip: "tooltip",
    trigger: "trigger",
};
export const ICONS = {
    menu: "ellipsis",
};
export const activeAttr = "data-active";
//# sourceMappingURL=resources.js.map
